import gql from 'graphql-tag';

export const GET_JOB_SEARCH_ASSIST = gql`
  query GetJobSearchAssist($visitorId: UUID!, $tokens: [Base64Url!]!) {
    jobSearchAssist(visitorId: $visitorId, tokens: $tokens) {
      pills {
        data {
          isActive
          keywords
          label
          stateToken
        }
        token
      }
    }
  }
`;
